import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';

const Orders = {
  Helmet: lazy(() => import('./components/OrdersHelmet.tsx')),
  DigitalPositions: lazyNamed(() => import('./containers/DigitalPositions/index.tsx'), 'DigitalPositions'),
  PrintPositions: lazyNamed(() => import('./containers/PrintPositions/index.tsx'), 'PrintPositions'),
  ConsultingPositions: lazyNamed(() => import('./containers/ConsultingPositions/index.tsx'), 'ConsultingPositions'),
  PositionHistory: {
    Component: lazy(() => import('./containers/PositionHistory/index.tsx')),
    Providers: lazy(() => import('./containers/PositionHistory/components/Providers.tsx')),
  },
  Forecast: lazyNamed(() => import('./containers/Forecast/index.tsx'), 'Forecast'),
  BroadcastPositions: lazyNamed(() => import('./containers/BroadcastPositions/index.tsx'), 'BroadcastPositions'),
  Booking: lazyNamed(() => import('./containers/Booking/index.tsx'), 'Booking'),
  Campaigns: {
    CampaignsList: lazyNamed(() => import('./containers/Campaigns/pages/CampaignsList/index.tsx'), 'CampaignsList'),
    Order: lazyNamed(() => import('./containers/Campaigns/pages/Order/index.tsx'), 'Order'),
    CampaignOverview: lazyNamed(() => import('./containers/Campaigns/pages/CampaignOverview/index.tsx'), 'CampaignOverview'),
  },
  PointOfSalePositions: lazyNamed(() => import('./containers/PointOfSalePositions/index.tsx'), 'PointOfSalePositions'),
};

export default Orders;
